import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PublicNavigationComponent } from "../public-navigation/public-navigation.component";
import { PublicFooterComponent } from "../footer/footer.component";

@Component({
  selector: 'app-terms',
  imports: [CommonModule, RouterModule, PublicNavigationComponent, PublicFooterComponent],
  templateUrl: './terms.component.html',
  styleUrl: './terms.component.scss'
})
export class TermsComponent {}
